"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWaybillMappingsResponseToJSON = exports.GetWaybillMappingsResponseFromJSONTyped = exports.GetWaybillMappingsResponseFromJSON = exports.instanceOfGetWaybillMappingsResponse = void 0;
var GetWaybillMappingsResponseItem_1 = require("./GetWaybillMappingsResponseItem");
/**
 * Check if a given object implements the GetWaybillMappingsResponse interface.
 */
function instanceOfGetWaybillMappingsResponse(value) {
    return true;
}
exports.instanceOfGetWaybillMappingsResponse = instanceOfGetWaybillMappingsResponse;
function GetWaybillMappingsResponseFromJSON(json) {
    return GetWaybillMappingsResponseFromJSONTyped(json, false);
}
exports.GetWaybillMappingsResponseFromJSON = GetWaybillMappingsResponseFromJSON;
function GetWaybillMappingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': json['results'] == null ? undefined : (json['results'].map(GetWaybillMappingsResponseItem_1.GetWaybillMappingsResponseItemFromJSON)),
    };
}
exports.GetWaybillMappingsResponseFromJSONTyped = GetWaybillMappingsResponseFromJSONTyped;
function GetWaybillMappingsResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'results': value['results'] == null ? undefined : (value['results'].map(GetWaybillMappingsResponseItem_1.GetWaybillMappingsResponseItemToJSON)),
    };
}
exports.GetWaybillMappingsResponseToJSON = GetWaybillMappingsResponseToJSON;
